import { render, staticRenderFns } from "./PurchaseRequisitionDisplayView.vue?vue&type=template&id=306ae4b1"
import script from "./PurchaseRequisitionDisplayView.vue?vue&type=script&lang=js"
export * from "./PurchaseRequisitionDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports